export enum FeedbackType {
    NEUTRAL = 0,
    POSITIVE = 1,
    NEGATIVE = 2
}